import { BodyText, Collapsible } from "@/components/ui";
import { ServiceRequest } from "@curai/js-fhir-tools";
import { format } from "date-fns";
import type * as fhirTypes from "fhir/r4";
import { ClipboardPlus } from "lucide-react";

interface LabProps {
  labTest: fhirTypes.ServiceRequest;
}

export const Lab = ({ labTest }: LabProps) => {
  const serviceRequest = new ServiceRequest(labTest);
  return (
    <Collapsible
      title={serviceRequest.displayName}
      headerSize="sm"
      status={serviceRequest.orderStatusLabel}
    >
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <BodyText tag="p" size="sm" bold>
            Remind On
          </BodyText>
          <BodyText tag="p" size="sm">
            {serviceRequest.reminderDate
              ? format(new Date(serviceRequest.reminderDate), "MMM d, yyyy")
              : "N/A"}
          </BodyText>
        </div>

        <div className="flex items-center gap-1">
          <ClipboardPlus size={12} />
          <BodyText tag="p" size="xs" textColor="secondary">
            Ordered by: {serviceRequest.requester?.display}
          </BodyText>
        </div>
      </div>
    </Collapsible>
  );
};
